import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent implements OnChanges {
  
  @Input() access: boolean;
  @Input() profileImg: Blob;
  @Input() isAdminUser: boolean;

  isExpanded = false;
  base64ProfilePhoto: any;

  // not sure this is used anymore
  // collapse() {
  //   this.isExpanded = false;
  // }

  constructor() { }

  ngOnChanges(): void {
    if (this.profileImg) {
      let reader = new FileReader();
      reader.onloadend = () => { this.base64ProfilePhoto = reader.result; }
      reader.readAsDataURL(this.profileImg);
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
